import React from 'react'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {
    GridToolbarContainer,
    GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { Box } from '@mui/system';

import { styled } from '@mui/material/styles';
import { LinearProgress, Stack, TextField, Typography } from '@mui/material';
import Slide from '@mui/material/Slide';

import { ConstructionOutlined, WarningAmber } from '@mui/icons-material';
import Grid from '@mui/material/Grid';

import PropTypes from 'prop-types';



//-------------------------------------------
export function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarFilterButton />
        </GridToolbarContainer>
    );
}



export function getListStyle(listlength, index, color) {
    if (listlength > 1 && index !== listlength - 1) {
        return { borderBottomWidth: '1px', borderBottomStyle: 'solid', borderColor: color }
    } else {
        return {}
    }

}



export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            sx={{ width: '100%' }}
            fullWidth={true}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3, width: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

export const TrialIcon = ({ isTest, size }) => {
    if (isTest) {
        return (<ConstructionOutlined sx={{ fontSize: size || '12px' }} />)
    } else {
        return (<></>)
    }

}

export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



export const MyBadge = ({ label, color, inverted, invisible }) => {
    if (inverted) {
        return (
            <Box  as="span" sx={{ backgroundColor: 'white', borderRadius: 2, borderWidth: '1px', borderStyle: 'solid', borderColor: color, color: color, width: 'auto', textAlign: 'center', pl: '3px', pr: '3px' }}>
                {label}
            </Box>
        )

    } else {
        return (
            <Box  as="span" sx={{ backgroundColor: color, borderRadius: 2, color: 'white', width: 'auto', textAlign: 'center', pl: '3px', pr: '3px', opacity: invisible && '0' }}>
                {label}
            </Box>
        )
    }
}



export const TestElement = ({ myparam, Icon }) => {
    return (
        <Box>
            {myparam}
            <Icon />
        </Box>
    )
}
export const WarningIcon = ({ label, size, showlabel }) => {
    return (
        <>
            <Grid container item>
                {showlabel &&
                    <EmptyLabel label={label} />
                }
                <Tooltip title={label} enterDelay={500}>
                    <WarningAmber sx={{ color: 'red', fontSize: size || '20px' }} />
                </Tooltip>
            </Grid>
        </>
    )
}

export const EmptyLabel = ({ label }) => {
    return (
        <Typography sx={{ fontSize: '11px !important', color: 'lightgrey' }}>
            {label}
        </Typography>

    )
    /*     return (
            <Tooltip title={label} enterDelay={500}>
                <SignalCellularConnectedNoInternet0Bar sx={{ color: 'orange' }} />
            </Tooltip>
        ) */
}


export const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'lightblue',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 'none',
        width: '400px',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export const MyTooltipChild = React.forwardRef((props, ref) => (
    <div {...props} ref={ref}>
        {props.children}
    </div>
))



export const MyBtnContent = (props) => {
    return (
        <Typography {...props}
            component="div"
            variant="subtitle1"
            color="inherit"
        >
            {props.children}
        </Typography>
    )
}